// Libs
import { useTranslation } from "react-i18next";

const Translator = ({ path, data }) => {
  const { t } = useTranslation();
  return t(`Checkout.${path}`, data);
};

export default Translator;